export default __webpack_public_path__ + "static/media/algorand.f755c537.svg";